export const Urls = {
    GetDocFleet: "company/GetDocFleet",
    GetCompany: "company",
    GetCompanySubscoreDetails: "company/SubscoreDetails",
    GetCompanyListFlags: "company/GetCompanyListFlags",
    GetBanners: "company/GetBanners",
    GetDocPerformance: "company/GetDocPerformance",
    GetGhgPerformance: "company/GetGhgPerformance",
    GetCompanyPerformanceDemography: "company/GetCompanyPerformanceDemography",
    GetCompanyVettingContact: "company/GetCompanyVettingContact",
    SaveCompanyVettingContact: "company/SaveCompanyVettingContact",
    RemoveCompanyVettingContact: "company/RemoveCompanyVettingContact",
    GetCompanyCertificates: "company/GetCompanyCertificates",
    SubmitManagementAudit: "company/SubmitManagementAudit",
    GetMaskDataForCompany: "company/GetMaskDataForCompany",
};
